import React from "react";

export default function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="82"
      height="81"
      viewBox="0 0 70 66"
      fill="none"
    >
      <ellipse
        cx="19.9496"
        cy="21.3023"
        rx="2.09999"
        ry="2.09524"
        fill="#F2D1E2"
      />
      <ellipse
        cx="5.59999"
        cy="39.4605"
        rx="2.09999"
        ry="2.09524"
        fill="#262C34"
      />
      <ellipse
        cx="5.59999"
        cy="39.4605"
        rx="2.09999"
        ry="2.09524"
        fill="#262C34"
      />
      <ellipse
        cx="37.4496"
        cy="63.9048"
        rx="2.09999"
        ry="2.09524"
        fill="#262C34"
      />
      <ellipse
        cx="21.7001"
        cy="40.5073"
        rx="2.09999"
        ry="2.09524"
        fill="#262C34"
      />
      <ellipse
        cx="26.2499"
        cy="27.937"
        rx="2.09999"
        ry="2.09524"
        fill="#262C34"
      />
      <line
        x1="35.2651"
        y1="21.4844"
        x2="35.2651"
        y2="5.65346"
        stroke="#262C34"
        strokeWidth="2"
      />
      <line
        y1="-1"
        x2="16.086"
        y2="-1"
        transform="matrix(-0.634097 -0.773253 0.77466 -0.632378 36.2651 19.2236)"
        stroke="#262C34"
        strokeWidth="2"
      />
      <line
        y1="-0.5"
        x2="13.6568"
        y2="-0.5"
        transform="matrix(-0.887135 -0.46151 0.463158 -0.886276 36.2651 19.2236)"
        stroke="#262C34"
      />
      <line
        y1="-0.5"
        x2="15.162"
        y2="-0.5"
        transform="matrix(-0.138504 -0.990362 0.990448 -0.137889 26.25 27.9365)"
        stroke="#262C34"
      />
      <line
        y1="-0.5"
        x2="9.54139"
        y2="-0.5"
        transform="matrix(0.403504 -0.914978 0.915651 0.401974 20.2998 21.6514)"
        stroke="#262C34"
      />
      <line
        y1="-0.5"
        x2="14.7574"
        y2="-0.5"
        transform="matrix(0.853807 -0.52059 0.522311 0.852755 5.94971 39.8096)"
        stroke="#262C34"
      />
      <line
        y1="-0.5"
        x2="9.08241"
        y2="-0.5"
        transform="matrix(-0.385359 -0.922767 0.923386 -0.383873 22.0498 40.5078)"
        stroke="#262C34"
      />
      <line
        y1="-0.5"
        x2="13.8513"
        y2="-0.5"
        transform="matrix(0.682246 0.731123 -0.732664 0.680591 27.9995 53.7773)"
        stroke="#262C34"
      />
      <line
        y1="-0.5"
        x2="12.6822"
        y2="-0.5"
        transform="matrix(0.910719 0.413026 -0.414581 0.910013 36.0498 37.3652)"
        stroke="#262C34"
      />
      <line
        y1="-0.5"
        x2="8.14972"
        y2="-0.5"
        transform="matrix(-0.515354 -0.856978 0.858007 -0.513638 52.1494 31.0791)"
        stroke="#262C34"
      />
      <line
        y1="-0.5"
        x2="9.87749"
        y2="-0.5"
        transform="matrix(0.141736 -0.989905 0.989994 0.141108 52.1494 31.0791)"
        stroke="#262C34"
      />
      <line
        y1="-1"
        x2="15.9761"
        y2="-1"
        transform="matrix(0.638459 -0.769656 0.771075 0.636744 37.4019 19.082)"
        stroke="#262C34"
        strokeWidth="2"
      />
      <line
        x1="35.2651"
        y1="36.1846"
        x2="35.2651"
        y2="23.746"
        stroke="#262C34"
        strokeWidth="2"
      />
      <line
        y1="-1"
        x2="31.1749"
        y2="-1"
        transform="matrix(-0.945215 0.326449 -0.327773 -0.944756 65.7339 26.0078)"
        stroke="#262C34"
        strokeWidth="2"
      />
      <line
        y1="-1"
        x2="16.9104"
        y2="-1"
        transform="matrix(-0.421777 0.9067 -0.907429 -0.420206 35.1323 38.4453)"
        stroke="#262C34"
        strokeWidth="2"
      />
      <line
        y1="-1"
        x2="15.3463"
        y2="-1"
        transform="matrix(0.912269 -0.409592 0.411139 0.911573 14 60.0635)"
        stroke="#262C34"
        strokeWidth="2"
      />
      <line
        y1="-1"
        x2="31.6075"
        y2="-1"
        transform="matrix(-0.968135 -0.25043 0.251496 -0.967858 34 36.1846)"
        stroke="#262C34"
        strokeWidth="2"
      />
      <line
        y1="-1"
        x2="17.5609"
        y2="-1"
        transform="matrix(-0.545612 -0.838038 0.839166 -0.543875 45.8501 52.0322)"
        stroke="#262C34"
        strokeWidth="2"
      />
      <line
        y1="-1"
        x2="14.0071"
        y2="-1"
        transform="matrix(0.974503 0.224376 -0.225344 0.974279 45.8501 52.0322)"
        stroke="#262C34"
        strokeWidth="2"
      />
      <ellipse cx="66" cy="25.9411" rx="3.99999" ry="3.99093" fill="#73D3CD" />
      <ellipse
        cx="35.9995"
        cy="3.99093"
        rx="3.99999"
        ry="3.99093"
        fill="#6061E5"
      />
      <ellipse
        cx="3.99999"
        cy="28.8689"
        rx="3.99999"
        ry="3.99093"
        fill="#73D3CD"
      />
      <ellipse
        cx="35.9995"
        cy="19.9538"
        rx="3.99999"
        ry="3.99093"
        fill="#6061E5"
      />
      <ellipse cx="52" cy="31.9275" rx="3.99999" ry="3.99093" fill="#6061E5" />
      <ellipse cx="46" cy="51.8825" rx="3.99999" ry="3.99093" fill="#6061E5" />
      <ellipse
        cx="27.8013"
        cy="53.7419"
        rx="3.99999"
        ry="3.99093"
        fill="#6061E5"
      />
      <ellipse cx="18" cy="31.9275" rx="3.99999" ry="3.99093" fill="#6061E5" />
      <ellipse
        cx="5.59999"
        cy="39.4605"
        rx="2.09999"
        ry="2.09524"
        fill="#73D3CD"
      />
      <ellipse
        cx="47.5995"
        cy="42.6031"
        rx="2.09999"
        ry="2.09524"
        fill="#73D3CD"
      />
      <ellipse
        cx="19.6"
        cy="21.6509"
        rx="2.09999"
        ry="2.09524"
        fill="#73D3CD"
      />
      <ellipse
        cx="35.9995"
        cy="37.9138"
        rx="3.99999"
        ry="3.99093"
        fill="#F2D1E2"
      />
      <ellipse
        cx="14.1499"
        cy="59.5144"
        rx="3.99999"
        ry="3.99093"
        fill="#F2D1E2"
      />
      <ellipse
        cx="59.6494"
        cy="55.3239"
        rx="3.99999"
        ry="3.99093"
        fill="#F2D1E2"
      />
      <ellipse cx="46" cy="5.98605" rx="3.99999" ry="3.99093" fill="#F2D1E2" />
      <ellipse cx="24" cy="5.98605" rx="3.99999" ry="3.99093" fill="#F2D1E2" />
      <ellipse
        cx="53.5502"
        cy="20.2534"
        rx="2.09999"
        ry="2.09524"
        fill="#F2D1E2"
      />
      <ellipse
        cx="24.1498"
        cy="12.9204"
        rx="2.09999"
        ry="2.09524"
        fill="#F2D1E2"
      />
      <ellipse
        cx="47.9501"
        cy="24.0952"
        rx="2.09999"
        ry="2.09524"
        fill="#F2D1E2"
      />
    </svg>
  );
}
